import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  { name: 'impoundTypeId', label: 'Property Tax Type', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'annualAmount', label: 'Annual Amount', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'monthlyAmount', label: 'Monthly Amount', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'frequency', label: 'Frequency', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'paidThroughDate', label: 'Paid Through Date', levelType: AutoLockFormsLevelType.FIELD },
  {
    name: 'lastPaymentAmount',
    label: 'Last Payment Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  { name: 'amountDueDates', label: 'Amount Due Dates', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'dueDate', label: 'Due Date', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'amountDue', label: 'Amount Due', levelType: AutoLockFormsLevelType.FIELD },
  {
    name: 'qualifyingForMonthlyAmount',
    label: 'Qualifying for Monthly Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const propertyTaxesForm = {
  name: FormNames.PROPERTY_TAXES,
  label: 'Property Taxes',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
